module.exports = __webpack_public_path__ + "static/media/arrow-right.18f7941e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right.svg
// module id = 429
// module chunks = 0